import { useSelector } from 'react-redux';
import { selectUser } from 'redux/user/selectors';
import { NativeAccessCode, User } from 'types';

export function useCurrentUser() {
  const user: User | null = useSelector(selectUser);

  return { user }
}

export function useIsCurrentUserSuperAdmin(): { loading: boolean, isCurrentUserSuperAdmin: boolean } {
  const { user } = useCurrentUser();

  return {
    loading: !user,
    isCurrentUserSuperAdmin: user ? isSuperAdmin(user) : false,
  }
}

/**
 * BC staff. Read from the api's permissionCodes, which carry super.admin for
 * either token kind (the AMS bitmap, or the super_admin MP role on Cognito), so
 * a listed user, which carries no permissionCodes, never counts.
 */
export function isSuperAdmin(user: User): boolean {
  return Boolean(user.permissionCodes?.includes(NativeAccessCode.SUPER_ADMIN));
}
